/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ClothesShoesSneakersIcon20Solid = forwardRef('ClothesShoesSneakersIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7 4.462c0-.839.933-1.34 1.632-.877l2.685 1.776-1.326 1.99a.625.625 0 1 0 1.04.693l1.328-1.993 1.625 1.076-1.247 1.87a.625.625 0 0 0 1.04.694l1.25-1.874 2.069 1.37C18.404 10.053 19 11.474 19 13H1V6.41c0-.995 1.254-1.434 1.874-.656.576.723 1.114 1.493 2.145 1.493A1.981 1.981 0 0 0 7 5.267v-.805Z" }),
        React.createElement("path", { d: "M1 14.25v.747a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-.747H1Z" })));
});
